<mat-list-option [value]="item.id" [selected]="item.id === selectedId" (click)="selectItem(item)" class="account-list-item">
	<span matListItemIcon>
		<mat-icon class="account-select-icon" svgIcon="{{ selectedId === item.id ? 'acies_check' : 'acies_uncheck' }}"></mat-icon>
	</span>
	<div matListItemLine class="account-text mat-caption" style="margin: 0">{{ item.name }}</div>
</mat-list-option>
